const quizRoot = document.querySelector('[data-routine-quiz]');

if (quizRoot) {
  const resultUrls = {
    starter: quizRoot.dataset.starterUrl || '/#bundle-selector',
    total: quizRoot.dataset.totalUrl || '/#bundle-selector',
    complete: quizRoot.dataset.completeUrl || '/#bundle-selector',
    year: quizRoot.dataset.yearUrl || '/#bundle-selector',
  };

  const screens = {
    intro: quizRoot.querySelector('[data-quiz-screen="intro"]'),
    question: quizRoot.querySelector('[data-quiz-screen="question"]'),
    result: quizRoot.querySelector('[data-quiz-screen="result"]'),
  };

  const startBtn = quizRoot.querySelector('[data-quiz-start]');
  const backBtn = quizRoot.querySelector('[data-quiz-back]');
  const restartBtn = quizRoot.querySelector('[data-quiz-restart]');
  const stepEl = quizRoot.querySelector('[data-quiz-step]');
  const progressEl = quizRoot.querySelector('[data-quiz-progress]');
  const questionEl = quizRoot.querySelector('[data-quiz-question]');
  const optionsEl = quizRoot.querySelector('[data-quiz-options]');
  const resultTitleEl = quizRoot.querySelector('[data-quiz-result-title]');
  const resultBodyEl = quizRoot.querySelector('[data-quiz-result-body]');
  const resultReasonsEl = quizRoot.querySelector('[data-quiz-result-reasons]');
  const resultCtaEl = quizRoot.querySelector('[data-quiz-result-cta]');
  const redirectNoteEl = quizRoot.querySelector('[data-quiz-redirect-note]');

  // Quiz results go straight to the matched bundle's product page, tagged so that
  // page can hide alternative-bundle choices for quiz visitors only.
  function withQuizParam(url) {
    if (!url || !url.startsWith('/products/')) return url;
    return `${url}${url.includes('?') ? '&' : '?'}from=quiz`;
  }

  const questions = [
    {
      id: 'goal',
      prompt: 'What are you trying to improve most right now?',
      options: [
        { value: 'fuller', label: 'Fuller-looking hair' },
        { value: 'scalp', label: 'Healthier-looking scalp' },
        { value: 'routine', label: 'A better daily routine' },
        { value: 'consistency', label: 'More visible consistency' },
        { value: 'confidence', label: 'A more confident appearance' },
      ],
    },
    {
      id: 'past_issue',
      prompt: 'What has been your biggest issue with hair support companies in the past?',
      options: [
        { value: 'not_system', label: 'Didn’t feel like a real system' },
        { value: 'hard_daily', label: 'Too hard to use daily' },
        { value: 'expensive_one', label: 'Too expensive for one product' },
        { value: 'lifestyle', label: 'Didn’t fit my lifestyle' },
        { value: 'not_consistent', label: 'I wasn’t consistent enough' },
      ],
    },
    {
      id: 'consistency_blocker',
      prompt: 'What usually keeps you from staying consistent?',
      options: [
        { value: 'forget', label: 'I forget after a few days' },
        { value: 'takes_long', label: 'The routine takes too long' },
        { value: 'not_together', label: 'I never knew what to use together' },
        { value: 'visible_change', label: 'I wanted more visible progress' },
        { value: 'ready', label: 'Nothing — I’m ready to commit' },
      ],
    },
    {
      id: 'mindset',
      prompt: 'Which statement sounds most like you right now?',
      options: [
        { value: 'try', label: 'I want to test a real routine first' },
        { value: 'transform', label: 'I’m ready for a noticeable change' },
        { value: 'commit', label: 'I’m ready to stay consistent for full benefits' },
        { value: 'value', label: 'I want the best value and do this right' },
      ],
    },
  ];

  const results = {
    starter: {
      title: 'Your best match: The 30-Day Starter Special',
      body: 'A simple way to start the Andros routine without overcommitting. Built for men who want to begin with daily support and see how a real hair routine fits into their life.',
      ctaLabel: 'Start With 30 Days',
      url: resultUrls.starter,
      protocolKey: 'starter',
    },
    total: {
      title: 'Your best match: The 60-Day Total Hair Protocol',
      body: 'A more complete inside-and-out routine built for men who are ready to commit to two months of daily consistency.',
      ctaLabel: 'Start The 60-Day Protocol',
      url: resultUrls.total,
      protocolKey: 'total',
    },
    complete: {
      title: 'Your best match: The Complete 100-Day Protocol',
      body: 'Built for men who are ready to commit to a stronger-looking routine long enough to capture the full benefits of daily consistency.',
      ctaLabel: 'Get The 100-Day Protocol',
      url: resultUrls.complete,
      protocolKey: 'complete',
    },
    year: {
      title: 'Your best match: The Andros Year Protocol',
      body: 'The highest-value Andros protocol for men who are ready to stop restarting, stay consistent, and lock in the best long-term value.',
      ctaLabel: 'Get The Year Protocol',
      url: resultUrls.year,
      protocolKey: 'year',
    },
  };

  const answers = {};
  let currentIndex = -1;

  function showScreen(screenName) {
    Object.entries(screens).forEach(([name, element]) => {
      if (!element) return;
      element.hidden = name !== screenName;
    });
  }

  function getOptionLabel(questionId, optionValue) {
    const question = questions.find((item) => item.id === questionId);
    return question?.options.find((option) => option.value === optionValue)?.label || '';
  }

  function renderQuestion() {
    const question = questions[currentIndex];
    if (!question) return;

    showScreen('question');
    stepEl.textContent = `Question ${currentIndex + 1} of ${questions.length}`;
    progressEl.style.width = `${((currentIndex + 1) / questions.length) * 100}%`;
    questionEl.textContent = question.prompt;
    backBtn.hidden = currentIndex === 0;

    optionsEl.innerHTML = question.options.map((option) => `
      <button type="button" class="routine-quiz__option" data-option-value="${option.value}">
        <span class="routine-quiz__option-label">${option.label}</span>
        <span class="routine-quiz__option-arrow" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 9H14M10 5l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </button>
    `).join('');

    optionsEl.querySelectorAll('[data-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        answers[question.id] = button.dataset.optionValue;

        if (currentIndex === questions.length - 1) {
          showResult();
          return;
        }

        currentIndex += 1;
        renderQuestion();
      });
    });
  }

  function getScores() {
    const scores = {
      starter: 0,
      total: 0,
      complete: 0,
      year: 0,
    };

    switch (answers.goal) {
      case 'routine':
        scores.starter += 2;
        scores.total += 1;
        break;
      case 'scalp':
        scores.total += 2;
        scores.complete += 1;
        break;
      case 'consistency':
        scores.total += 2;
        scores.complete += 2;
        break;
      case 'confidence':
        scores.total += 2;
        scores.complete += 1;
        scores.year += 1;
        break;
      case 'fuller':
      default:
        scores.total += 2;
        scores.complete += 1;
        scores.year += 1;
        break;
    }

    switch (answers.past_issue) {
      case 'not_system':
        scores.total += 2;
        scores.complete += 1;
        break;
      case 'hard_daily':
        scores.starter += 2;
        scores.total += 1;
        break;
      case 'expensive_one':
        scores.starter += 1;
        scores.year += 2;
        break;
      case 'lifestyle':
        scores.complete += 2;
        scores.total += 1;
        break;
      case 'not_consistent':
        scores.starter += 1;
        scores.complete += 2;
        scores.year += 1;
        break;
      default:
        break;
    }

    switch (answers.consistency_blocker) {
      case 'forget':
        scores.starter += 2;
        scores.total += 1;
        break;
      case 'takes_long':
        scores.starter += 1;
        scores.complete += 2;
        break;
      case 'not_together':
        scores.total += 2;
        scores.complete += 1;
        break;
      case 'visible_change':
        scores.total += 2;
        scores.complete += 1;
        break;
      case 'ready':
        scores.complete += 2;
        scores.year += 2;
        break;
      default:
        break;
    }

    switch (answers.mindset) {
      case 'try':
        scores.starter += 5;
        break;
      case 'transform':
        scores.total += 5;
        break;
      case 'commit':
        scores.complete += 5;
        break;
      case 'value':
        scores.year += 5;
        break;
      default:
        break;
    }

    return scores;
  }

  function getResultKey() {
    const scores = getScores();

    return Object.entries(scores).sort((left, right) => right[1] - left[1])[0]?.[0] || 'starter';
  }

  function buildReasons(resultKey) {
    const reasons = [];
    const goalLabel = getOptionLabel('goal', answers.goal);
    const pastIssueLabel = getOptionLabel('past_issue', answers.past_issue);
    const blockerLabel = getOptionLabel('consistency_blocker', answers.consistency_blocker);
    const mindsetLabel = getOptionLabel('mindset', answers.mindset);

    if (goalLabel) {
      reasons.push(`You said your main priority is ${goalLabel.toLowerCase()}, so we matched you to the level of routine commitment most likely to support that goal.`);
    }

    if (pastIssueLabel) {
      reasons.push(`Your biggest frustration was "${pastIssueLabel}", which pointed us toward the protocol that best removes that friction.`);
    }

    if (blockerLabel) {
      reasons.push(`You also called out "${blockerLabel}" as the thing that gets in the way, so we kept consistency front and center in the recommendation.`);
    }

    if (mindsetLabel && resultKey === 'year') {
      reasons.push(`You chose "${mindsetLabel}," which clearly signals a long-term value mindset over a short-term test.`);
    } else if (mindsetLabel && resultKey === 'complete') {
      reasons.push(`You chose "${mindsetLabel}," which is why we leaned toward the protocol built for full-benefit consistency.`);
    } else if (mindsetLabel && resultKey === 'total') {
      reasons.push(`You chose "${mindsetLabel}," which lines up with a more complete daily routine.`);
    } else if (mindsetLabel && resultKey === 'starter') {
      reasons.push(`You chose "${mindsetLabel}," which makes a simpler starting routine the strongest fit right now.`);
    }

    return reasons.slice(0, 3);
  }

  function showResult() {
    const resultKey = getResultKey();
    const result = results[resultKey];

    resultTitleEl.textContent = result.title;
    resultBodyEl.textContent = result.body;
    const destination = withQuizParam(result.url);
    const willRedirect = destination !== result.url;

    resultCtaEl.textContent = result.ctaLabel;
    resultCtaEl.setAttribute('href', destination);
    resultReasonsEl.innerHTML = buildReasons(resultKey)
      .map((reason) => `<div class="routine-quiz__insight">${reason}</div>`)
      .join('');

    if (redirectNoteEl) redirectNoteEl.hidden = !willRedirect;

    showScreen('result');

    if (willRedirect) {
      // Immediate redirect; the result screen and CTA stay as a fallback link.
      window.location.assign(destination);
      return;
    }

    document.dispatchEvent(new CustomEvent('protocol:select', {
      bubbles: true,
      detail: {
        key: result.protocolKey,
        title: result.title,
        body: result.body,
      },
    }));
  }

  function resetQuiz() {
    Object.keys(answers).forEach((key) => delete answers[key]);
    if (redirectNoteEl) redirectNoteEl.hidden = true;
    currentIndex = -1;
    progressEl.style.width = '0';
    showScreen('intro');
  }

  startBtn?.addEventListener('click', () => {
    currentIndex = 0;
    renderQuestion();
  });

  backBtn?.addEventListener('click', () => {
    if (currentIndex <= 0) return;
    currentIndex -= 1;
    renderQuestion();
  });

  restartBtn?.addEventListener('click', resetQuiz);

  resetQuiz();
}
